"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModules = void 0;
var tslib_1 = require("tslib");
var getModules = function (bffApi) {
    var e_1, _a;
    var module = {};
    var _loop_1 = function (fnName, fns) {
        var bffFn = fns.bffFn;
        module[fnName] = function () {
            var input = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                input[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, bffFn.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(input), false))];
            }); });
        };
    };
    try {
        for (var _b = tslib_1.__values(Object.entries(bffApi)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), fnName = _d[0], fns = _d[1];
            _loop_1(fnName, fns);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return module;
};
exports.getModules = getModules;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/utils/module.util.js
// module id = 832
// module chunks = 11